<template>
  <div :id="`${source}_call_note`">
    <a-textarea
      ref="textareaRef"
      :value="modelValue"
      @update:value="updateNote"
      class="textarea_large resize-none w-96"
      style="height: 280px"
      placeholder="Add your call notes here..."
    />
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { onMounted, ref } from "vue";

const store = useStore();
const props = defineProps({
  source: { type: String, required: true },
  modelValue: { type: String, required: true },
});

const emit = defineEmits(["update:modelValue"]);

const textareaRef = ref(null);

const updateNote = (value) => {
  emit("update:modelValue", value);
  store.dispatch("calls/setCallNote", value);
};

onMounted(() => {
  textareaRef.value?.focus();
});
</script>
